export default "/images/My_Hover.svg?770df0fc783c03d4dda6365dcca40881";